export const CHANGE_MODAL_VISIBILITY = 'changeModalVisibilityModals';